module.exports = __webpack_public_path__ + "media/images/flags/ar-2ff091f8773d0ea8640d60a3a286481b.svg";